import React, { useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Close } from '@material-ui/icons';
import VideoPlayer from './video-player.widget';

const containerVariants = {
    hide: {
        opacity: 0,
        y: '100%',
        x: '-50%'
    },
    show: {
        opacity: 1,
        y: '-50%',
        x: '-50%',
        transition: {
            duration: 1,
            ease: 'easeInOut'
        }
    },
    end: {
        opacity: 0,
        transition: {
            duration: 0
        }
    }
};

const backdropVariants = {
    hidden: {
        opacity: 0,
    },
    visible: {
        opacity: 1,
        transition: {
            duration: 1,
            ease: 'easeInOut'
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0
        }
    }
};

const VideoLightbox = ({ isOpen, onClose, videoSrc }) => {
    const playerRef = useRef(null);

    const handleClose = useCallback(() => {
        playerRef.current?.stop();
        onClose();
    }, [onClose]);

    useEffect(() => {
        if (!isOpen) {
            document.body.classList.remove('modal-open');
            return undefined;
        }

        document.body.classList.add('modal-open');

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }

            if (e.key === ' ' || e.code === 'Space') {
                e.preventDefault();
                playerRef.current?.togglePlay();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            document.body.classList.remove('modal-open');
        };
    }, [isOpen, handleClose]);

    return ReactDOM.createPortal(
        <AnimatePresence exitBeforeEnter>
            {isOpen && (
                <motion.div
                    variants={backdropVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    className="backdrop"
                    key="video-lightbox-backdrop"
                    onClick={handleClose}
                />
            )}
            {isOpen && (
                <motion.div
                    variants={containerVariants}
                    initial="hide"
                    animate="show"
                    exit="end"
                    className="modal video-lightbox"
                    key="video-lightbox"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="video-lightbox-header">
                        <h3>Video</h3>
                        <Close onClick={handleClose} aria-label="Schließen" />
                    </div>
                    <div className="video-lightbox-body">
                        <VideoPlayer ref={playerRef} src={videoSrc} autoPlay />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>,
        document.body
    );
};

export default VideoLightbox;
